import {
  Button,
  Dialog,
  DialogActions, DialogContent, DialogContentText, DialogTitle, Typography,
} from '@mui/material';
import { style } from '@/styles/globals';
import { pr } from '@/utils/pxToRem';
import { styled } from '@mui/system';
import { useRouter } from 'next/router';
import { captureException } from '@sentry/nextjs';
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { resetGlobalAll } from '@/slices/global/globalSlice';
import { isArray } from 'lodash';
import { getParamsBusMapping, getParamsFlightMapping } from '@/utils/paramsMapping';
import { setFlightErrorId } from '@/slices/flightData/slices/flightDataSlice';
import { useEffect } from 'react';

const StyledDialogTitle = styled(DialogTitle)({
  fontWeight: 'bold',
  padding: 0,
});
const StyledButton = styled(Button)({
  ...style.text.content.bold,
  color: 'white',
  flex: '1 1 1px',
  padding: `${pr`12px`} ${pr`16px`}`,
});
const StyledDialogActions = styled(DialogActions)({
  display: 'flex',
  justifyContent: 'space-between',
  padding: 0,
});
const StyledDialogContent = styled(DialogContent)({
  padding: 0,
  marginTop: pr`16px`,
  marginBottom: '1.5em',
});
const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    background: ${style.color.white4};
    border: 1px solid ${style.color.white3};
    box-sizing: border-box;
    box-shadow: ${style.boxShadow.popupShadow};
    border-radius: 16px;
  }
`;

function ReserveErrorDialogContainer({
  errorDialogOpen, setErrorDialogOpen, message, tab, error,
}: { errorDialogOpen: boolean, setErrorDialogOpen(status: boolean): void, message: string, tab: string, error: any }) {
  const { push } = useRouter();
  const dispatch = useAppDispatch();
  const stateSelectedDate = useAppSelector(
    (state) => state.calendar.selectedDate,
  );
  const {
    startPointHome: startPointHomeBus,
    toPointHome: toPointHomeBus,
    passenger: passengerBus,
  } = useAppSelector((state) => state.searchBusForm);

  const {
    passenger: passengerFlight,
    seatClass: seatClassFlight,
    startPointHome: startPointFlight,
    toPointHome: toPointFlight,
  } = useAppSelector((state) => state.searchFlightForm);

  useEffect(() => {
    if (!message && error) {
      captureException(error);
    }
  }, [message, error]);

  let path = '';
  const selectedDate = {
    depart: stateSelectedDate?.depart ? new Date(stateSelectedDate?.depart) : new Date(),
    return: stateSelectedDate?.return ? new Date(stateSelectedDate.return) : null,
  };

  let searchPath = '';
  const selectedFlight = useAppSelector((state) => state.selectedFlight);
  const isReturn = !!selectedFlight?.returnFlight;

  switch (tab) {
    case 'flight':
      dispatch(setFlightErrorId(isReturn ? selectedFlight?.returnFlight?.idIndex : selectedFlight?.flight?.idIndex));
      path = getParamsFlightMapping({
        tmpPassenger: passengerFlight,
        tmpSeatClass: seatClassFlight,
        tmpToPoint: toPointFlight || undefined,
        tmpStartPoint: startPointFlight || undefined,
        tmpSelectedDate: {
          depart: `${selectedDate.depart}`,
          return: selectedDate.return ? `${selectedDate.return}` : null,
        },
      });
      searchPath = path;
      break;
    case 'bus':
      path = getParamsBusMapping({
        tmpPassenger: passengerBus,
        tmpSelectedDate: selectedDate as any,
        tmpToPoint: toPointHomeBus as any,
        tmpStartPoint: startPointHomeBus as any,
      });
      searchPath = path;
      break;
    default:
      break;
  }

  return (
    <StyledDialog
      open={errorDialogOpen}
      onClose={() => {
        setErrorDialogOpen(false);
        dispatch(resetGlobalAll());
        push(searchPath, undefined, { shallow: true });
      }}
      PaperProps={{
        style: {
          padding: pr`16px`,
          minWidth: '250px',
        },
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <StyledDialogTitle
        sx={{
          textAlign: 'center',
        }}
        id="alert-dialog-title"
      >
        <Typography
          variant="subtitle2"
          color={style.color.black1}
        >
          Có lỗi xảy ra
        </Typography>
      </StyledDialogTitle>
      <StyledDialogContent>
        <DialogContentText id="alert-dialog-description">
          {!!message && (
          <Typography variant="caption">
            {isArray(message)
              ? message.join(', ')
              : message}
          </Typography>
          )}
          {!message && (
          <Typography variant="caption">
            Kết nối đến hệ thống tạm thời gián đoạn. Quý khách vui lòng thử lại sau.
          </Typography>
          )}
        </DialogContentText>
      </StyledDialogContent>
      <StyledDialogActions>
        <StyledButton
          style={{ background: style.color.blue3 }}
          variant="contained"
          onClick={() => {
            setErrorDialogOpen(false);
            dispatch(resetGlobalAll());
            push(searchPath, undefined, { shallow: true });
          }}
        >
          Tìm vé mới
        </StyledButton>
      </StyledDialogActions>
    </StyledDialog>
  );
}

export default ReserveErrorDialogContainer;
